// fetch() rejects only on a network failure (dropped connection, DNS, abort), so tag it right
// at the boundary. Callers must NOT infer this from `error instanceof TypeError` further down
// the chain: a .then() handler that throws its own TypeError is indistinguishable that way, and
// the #2089 / #2022 / #2340 family of real bugs were exactly that shape — they would be
// misreported as harmless connection drops.
export const tagNetworkFailure = (err) => {
    if (err && typeof err === "object") err.isNetworkFailure = true;

    throw err;
};

// fetch() resolves as soon as the status line and headers are in; the body is still streaming.
// If the connection drops after that, response.json() / response.text() reject with a TypeError
// carrying the very same wording as a failed fetch() ("Failed to fetch" on Chromium, "Load
// failed" on Safari, "NetworkError when attempting to fetch resource." on Firefox) — but out of
// reach of tagNetworkFailure, so the boundary-tag rule above sent it to the "real bug" branch
// (Rollbar #439: a 201 from /api/auth/login followed 120ms later by a *critical* "Silent login
// error: TypeError: Failed to fetch"). Attach this to the body read alone, never to a wider
// chain: a malformed body is a SyntaxError and stays untagged, so a 2xx that serves an HTML
// error page still reports at full severity.
export const tagBodyReadFailure = (err) => {
    if (err instanceof TypeError) err.isNetworkFailure = true;

    throw err;
};
